import ExclusiveRewardsCarousel from './ExclusiveRewardsCarousel';

export default ExclusiveRewardsCarousel;
